// ['13 - Hannah',
// '29 - Tilly',
// '21 - Milly',
// '5 - Barrett Bamboo',
// '53 - Wilton',
// '9 - Evy',
// '12 - Hailey',
// '10 - Flora',
// '8 - Eleanor',
// '24 - Oscar']

import dummy from "../assets/images/dummy.svg";
import offsetRandom from "../assets/images/widePlank/offsetRandom.jpg";
import eightInch from "../assets/images/widePlank/8in.jpg";

//////////////////////////////
export const configuratorData5 = {
  tokenUrl: "7aebc635-1bae-333d-b716-cd61c0955c90",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData5 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData5 = [
  {
    id: 1,
    name: "Barrett Bamboo Dining Chair",
    thumb: eightInch,
  },
];

export const sceneData5 = [
  {
    id: 24822,
    name: "Barrett Bamboo Dining Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData8 = {
  tokenUrl: "71341632-e1a1-3e2e-9451-a8483b1fa749",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData8 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData8 = [
  {
    id: 1,
    name: "Eleanor Chair",
    thumb: eightInch,
  },
];

export const sceneData8 = [
  {
    id: 24827,
    name: "Eleanor Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData9 = {
  tokenUrl: "f93c8574-145e-338e-8211-5251c9e45fbf",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData9 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData9 = [
  {
    id: 1,
    name: "Evy Chair",
    thumb: eightInch,
  },
];

export const sceneData9 = [
  {
    id: 24824,
    name: "Evy Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

///////////////////////////
export const configuratorData10 = {
  tokenUrl: "f65134fa-bfd2-3227-87c0-43ccaf7e87a5",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData10 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData10 = [
  {
    id: 1,
    name: "Flora Chair",
    thumb: eightInch,
  },
];

export const sceneData10 = [
  {
    id: 24826,
    name: "Flora Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData12 = {
  tokenUrl: "0b704ef2-b69e-31bc-a4e1-436b5969f8b4",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData12 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData12 = [
  {
    id: 1,
    name: "Hailey Swivel Chair",
    thumb: eightInch,
  },
];

export const sceneData12 = [
  {
    id: 24825,
    name: "Hailey Swivel Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData13 = {
  tokenUrl: "24b5513f-5ccb-3dc3-a596-2014fdf46bcf",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData13 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData13 = [
  {
    id: 1,
    name: "Hannah Chair",
    thumb: eightInch,
  },
  // {
  //   id: 2,
  //   name: "Hannah new",
  //   thumb: eightInch,
  // },
];

export const sceneData13 = [
  {
    id: 24819,
    name: "Hannah Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  // {
  //   id: 15247,
  //   name: "Scene",
  //   profileId: 1,
  //   layoutId: 2,
  //   thumb: dummy,
  // },
];

//////////////////////////////
export const configuratorData21 = {
  tokenUrl: "03bac2d3-2434-3dbe-9bab-0f91129ba5c0",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData21 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData21 = [
  {
    id: 1,
    name: "Milly Twin Sleeper Chair",
    thumb: eightInch,
  },
];

export const sceneData21 = [
  {
    id: 24821,
    name: "Milly Twin Sleeper Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData24 = {
  tokenUrl: "4db35856-e668-381a-9755-c3e5069aff1f",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData24 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData24 = [
  {
    id: 1,
    name: "Oscar Chair",
    thumb: eightInch,
  },
];

export const sceneData24 = [
  {
    id: 24828,
    name: "Oscar Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData29 = {
  tokenUrl: "d227805f-1d1f-3bf2-b2c1-37b46e7dcc36",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData29 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData29 = [
  {
    id: 1,
    name: "Tilly Spool Chair",
    thumb: eightInch,
  },
];

export const sceneData29 = [
  {
    id: 24820,
    name: "Tilly Spool Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData53 = {
  tokenUrl: "accde150-3cda-383b-9ece-924b9f6786cc",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData53 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData53 = [
  {
    id: 1,
    name: "Wilton Skirted Sofa",
    thumb: eightInch,
  },
];

export const sceneData53 = [
  {
    id: 24823,
    name: "Wilton Skirted Sofa",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData425 = {
  tokenUrl: "0f100ad5-2111-372e-b0aa-3034d2f55e62",
  id: 1,
  name: "Maine Cottage",
  arViewer: false,
  measureTool: false,
};

export const profileData425 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData425 = [
  {
    id: 1,
    name: "Wilton Skirtless Sofa",
    thumb: eightInch,
  },
];

export const sceneData425 = [
  {
    id: 26576,
    name: "Wilton Sofa Skirtless",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData222 = {
  tokenUrl: "1704b974-f51e-37e0-a846-343bff692dab",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData222 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData222 = [
  {
    id: 1,
    name: "Jill Dining Chair",
    thumb: eightInch,
  },
];

export const sceneData222 = [
  {
    id: 24829,
    name: "Jill Dining Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData76 = {
  tokenUrl: "d06e09b0-9802-3b01-991d-2de31af20179",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData76 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData76 = [
  {
    id: 1,
    name: "Tilly Ottomon",
    thumb: eightInch,
  },
];

export const sceneData76 = [
  {
    id: 24838,
    name: "Tilly Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData68 = {
  tokenUrl: "b10deaf2-5692-39c3-80cc-379d5d501353",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData68 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData68 = [
  {
    id: 1,
    name: "Milly Storage Ottomon",
    thumb: eightInch,
  },
];

export const sceneData68 = [
  {
    id: 24839,
    name: "Milly Storage Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData64 = {
  tokenUrl: "07d37735-0a80-381d-8187-a0ddedc05e9c",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData64 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData64 = [
  {
    id: 1,
    name: "James Ottomon",
    thumb: eightInch,
  },
];

export const sceneData64 = [
  {
    id: 24840,
    name: "James Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData57 = {
  tokenUrl: "e0c4bed8-8122-397d-b045-f43cc300d67f",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData57 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData57 = [
  {
    id: 1,
    name: "Cube Ottomon",
    thumb: eightInch,
  },
];

export const sceneData57 = [
  {
    id: 24841,
    name: "Cube Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData75 = {
  tokenUrl: "ac9237fb-0404-311c-b0cb-e2635f7d2471",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData75 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData75 = [
  {
    id: 1,
    name: "Suri Ottomon",
    thumb: eightInch,
  },
];

export const sceneData75 = [
  {
    id: 24842,
    name: "Suri Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData67 = {
  tokenUrl: "bc555048-96de-3e45-b5d0-c0f27d16e154",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData67 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData67 = [
  {
    id: 1,
    name: "Mia bench",
    thumb: eightInch,
  },
];

export const sceneData67 = [
  {
    id: 24843,
    name: "Mia bench",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData6 = {
  tokenUrl: "e84f31d0-e3fd-3b4f-83db-65e001a09f5f",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData6 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData6 = [
  {
    id: 1,
    name: "Billie Chair",
    thumb: eightInch,
  },
];

export const sceneData6 = [
  {
    id: 24844,
    name: "Billie Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData284 = {
  tokenUrl: "5ef703f6-cc88-34ef-ad86-8f4776d7d37c",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData284 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData284 = [
  {
    id: 1,
    name: "Ruben Hassock Ottomon",
    thumb: eightInch,
  },
];

export const sceneData284 = [
  {
    id: 24845,
    name: "Ruben Hassock Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData14 = {
  tokenUrl: "a59be6bc-f051-3495-92d9-10790dfee616",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData14 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData14 = [
  {
    id: 1,
    name: "Stationary",
    thumb: eightInch,
  },
   {
    id: 2,
    name: "Swivel",
    thumb: eightInch,
  },
];

export const sceneData14 = [
  {
    id: 24846,
    name: "Hazel Chair Stationary",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
   {
    id: 24847,
    name: "Hazel Chair Swivel",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
];

export const configuratorData422 = {
  tokenUrl: "a59be6bc-f051-3495-92d9-10790dfee616",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData422 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData422 = [
  {
    id: 1,
    name: "Stationary",
    thumb: eightInch,
  }
];

export const sceneData422 = [
  {
    id: 24846,
    name: "Hazel Chair Stationary",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
];

export const configuratorData423 = {
  tokenUrl: "a59be6bc-f051-3495-92d9-10790dfee616",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData423 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData423 = [
  
   {
    id: 1,
    name: "Swivel",
    thumb: eightInch,
  },
];

export const sceneData423 = [
  
   {
    id: 24847,
    name: "Hazel Chair Swivel",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];
//////////////////////////////
export const configuratorData15 = {
  tokenUrl: "fbae4b9a-552b-3c7d-9d70-f7d498e49b43",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData15 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData15 = [
  {
    id: 1,
    name: "Stationary",
    thumb: eightInch,
  },
   {
    id: 2,
    name: "Swivel",
    thumb: eightInch,
  },
];

export const sceneData15 = [
  {
    id: 24848,
    name: "Henry Chair Stationary",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
   {
    id: 24849,
    name: "Henry Chair Swivel",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
];

export const configuratorData420 = {
  tokenUrl: "fbae4b9a-552b-3c7d-9d70-f7d498e49b43",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData420 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData420 = [
  {
    id: 1,
    name: "Stationary",
    thumb: eightInch,
  }
];

export const sceneData420 = [
  {
    id: 24848,
    name: "Henry Chair Stationary",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
];

export const configuratorData421 = {
  tokenUrl: "fbae4b9a-552b-3c7d-9d70-f7d498e49b43",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData421 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData421 = [
   {
    id: 1,
    name: "Swivel",
    thumb: eightInch,
  },
];

export const sceneData421 = [
   {
    id: 24849,
    name: "Henry Chair Swivel",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData121 = {
  tokenUrl: "b5ce1546-e8ee-302d-9c07-d702a6d6f7b1",
  id: 1,
  name: "Maine Cottage",
  arViewer: false,
  measureTool: true,
};

export const profileData121 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData121 = [
  {
    id: 2,
    name: "No Cushion",
    thumb: eightInch,
  },
  {
    id: 1,
    name: "Cokie Dining Chair",
    thumb: eightInch,
  },
];

export const sceneData121 = [
  {
    id: 24850,
     name: "Cokie Dining Chair - Painted",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
   {
    id: 24874,
    name: "Cokie Dining Chair - without cushion",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData113 = {
  tokenUrl: "9a1cdc29-9177-3089-ada9-d7414240b469",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData113 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData113 = [
   {
    id: 2,
    name: "No Cushion",
    thumb: eightInch,
  },
  {
    id: 1,
    name: "Boothbay Dining Chair",
    thumb: eightInch,
  }
];

export const sceneData113 = [
  {
    id: 24851,
    name: "Boothbay Dining Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24877,
    name: "Boothbay Dining Chair",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData73 = {
  tokenUrl: "ceddc73f-df20-3975-a861-9d1eb2d335ff",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData73 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData73 = [
  {
    id: 1,
    name: "Shelby Ottomon",
    thumb: eightInch,
  },
];

export const sceneData73 = [
  {
    id: 24852,
    name: "Shelby Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData72 = {
  tokenUrl: "8585e2c5-293c-32f4-b2d6-ed39bb611074",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData72 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData72 = [
  {
    id: 1,
    name: "Shelby Bench",
    thumb: eightInch,
  },
];

export const sceneData72 = [
  {
    id: 24853,
    name: "Shelby Bench",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData49 = {
  tokenUrl: "26896a01-c151-34fa-9d9f-287cd807863f",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData49 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData49 = [
  {
    id: 1,
    name: "Joey Sofa",
    thumb: eightInch,
  },
];

export const sceneData49 = [
  {
    id: 24509,
    name: "Joey Sofa",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];


//////////////////////////////
export const configuratorData62 = {
  tokenUrl: "dfa327c0-3f15-3434-b6dd-29f70d5553a7",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData62 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData62 = [
  {
    id: 1,
    name: "Flora Ottomon",
    thumb: eightInch,
  },
];

export const sceneData62 = [
  {
    id: 24855,
    name: "Flora Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData25 = {
  tokenUrl: "1f46a07f-784b-30cc-8114-09f15b94474b",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData25 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData25 = [
  {
    id: 1,
    name: "Piper Chair",
    thumb: eightInch,
  },
];

export const sceneData25 = [
  {
    id: 24856,
    name: "Piper Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];
//////////////////////////////
export const configuratorData51 = {
  tokenUrl: "2edd51bd-1e3c-3447-9646-cb2a61a14ae3",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData51 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData51 = [
  {
    id: 1,
    name: "Shelby Sofa",
    thumb: eightInch,
  },
];

export const sceneData51 = [
  {
    id: 24510,
    name: "Shelby Sofa",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData58 = {
  tokenUrl: "8dce26a5-c30d-357b-8a89-d340ab0d09f4",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData58 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData58 = [
  {
    id: 1,
    name: "Daphne Ottomon",
    thumb: eightInch,
  },
];

export const sceneData58 = [
  {
    id: 24858,
    name: "Daphne Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData69 = {
  tokenUrl: "b5b95484-e268-37de-8965-04c979e00fbe",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData69 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData69 = [
  {
    id: 1,
    name: "Morgan Ottomon",
    thumb: eightInch,
  },
];

export const sceneData69 = [
  {
    id: 24859,
    name: "Morgan Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData23 = {
  tokenUrl: "83e149f1-aa17-3b2c-a04f-a6e8b692dab0",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData23 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData23 = [
  {
    id: 1,
    name: "Olivia Chair",
    thumb: eightInch,
  },
];

export const sceneData23 = [
  {
    id: 24860,
    name: "Olivia Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData60 = {
  tokenUrl: "8f885c64-df62-3cc3-a04c-c26e1518338f",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData60 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData60 = [
  {
    id: 1,
    name: "Eloise Ottomon",
    thumb: eightInch,
  },
];

export const sceneData60 = [
  {
    id: 24861,
    name: "Eloise Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData132 = {
  tokenUrl: "832c78b8-3ed8-3772-97d5-69583b7c87d4",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData132 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData132 = [
  {
    id: 1,
    name: "Minnie Bar Stool",
    thumb: eightInch,
  },
];

export const sceneData132 = [
  {
    id: 24862,
    name: "Minnie Bar Stool",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData27 = {
  tokenUrl: "d046df21-0b64-349d-84b6-f82cb634ad44",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData27 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData27 = [
  {
    id: 1,
    name: "Shelby Chair",
    thumb: eightInch,
  },
];

export const sceneData27 = [
  {
    id: 24863,
    name: "Shelby Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData77 = {
  tokenUrl: "be205033-5e11-395d-9027-0aa11b4ecdd1",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData77 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData77 = [
  {
    id: 1,
    name: "Tulla Tuffet Ottomon",
    thumb: eightInch,
  },
];

export const sceneData77 = [
  {
    id: 24864,
    name: "Tulla Tuffet Ottomon",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData17 = {
  tokenUrl: "909df0bb-629a-3881-bed1-7fb444c48cd1",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData17 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData17 = [
  {
    id: 1,
    name: "Lilah Chair Swivel",
    thumb: eightInch,
  },
];

export const sceneData17 = [
  {
    id: 24865,
    name: "Lilah Chair Swivel",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];

//////////////////////////////
export const configuratorData123 = {
  tokenUrl: "660a1cee-2f9a-354c-8b23-8ed04ebd10af",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData123 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData123 = [
  {
    id: 2,
    name: "No Cushion",
    thumb: eightInch,
  },
  {
    id: 1,
    name: "Edna Dining Chair",
    thumb: eightInch,
  }
];

export const sceneData123 = [
  {
    id: 24866,
    name: "Edna Dining Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24876,
    name: "Edna Dining Chair - No cushion",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  }
];

//////////////////////////////
export const configuratorData124 = {
  tokenUrl: "2c13dff9-d8dd-311a-93d2-c072136b5849",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData124 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData124 = [
  {
    id: 1,
    name: "Ida Bar Stool Swivel",
    thumb: eightInch,
  },
];

export const sceneData124 = [
  {
    id: 24867,
    name: "Ida Bar Stool Swivel",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];


//////////////////////////////
export const configuratorData3 = {
  tokenUrl: "bd949c5e-4627-3ba5-9c3a-ba08bca3c6e9",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData3 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData3 = [
  {
    id: 1,
    name: "Astrid Chair",
    thumb: eightInch,
  },
];

export const sceneData3 = [
  {
    id: 24868,
    name: "Astrid Chair",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];


//////////////////////////////
export const configuratorData50 = {
  tokenUrl: "74408d5d-d931-3c85-b261-9d2e4cfa6416",
  id: 1,
  name: "Maine Cottage",
  arViewer: true,
  measureTool: true,
};

export const profileData50 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData50 = [
  {
    id: 1,
    name: "Monty Sofa",
    thumb: eightInch,
  },
];

export const sceneData50 = [
  {
    id: 24534,
    name: "Monty Sofa",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
];